import { render, staticRenderFns } from "./AnnualBilling.vue?vue&type=template&id=bba8a4ec&"
import script from "./AnnualBilling.vue?vue&type=script&lang=ts&"
export * from "./AnnualBilling.vue?vue&type=script&lang=ts&"
import style0 from "./AnnualBilling.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports